/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rsvpfeature1Inputs */

const en_rsvpfeature1 = /** @type {(inputs: Rsvpfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow declines`)
};

const de_rsvpfeature1 = /** @type {(inputs: Rsvpfeature1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absagen erlauben`)
};

/**
* | output |
* | --- |
* | "Allow declines" |
*
* @param {Rsvpfeature1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const rsvpfeature1 = /** @type {((inputs?: Rsvpfeature1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rsvpfeature1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rsvpfeature1(inputs)
	return de_rsvpfeature1(inputs)
});
export { rsvpfeature1 as "rsvpFeature" }